export enum PermissionType {
    INDEX_USER = 'INDEX_USER',
    SHOW_USER = 'SHOW_USER',
    STORE_USER = 'STORE_USER',
    UPDATE_USER = 'UPDATE_USER',
    DELETE_USER = 'DELETE_USER',
    SHOW_ROLE = 'SHOW_ROLE',
    STORE_ROLE = 'STORE_ROLE',
    DELETE_ROLE = 'DELETE_ROLE',
    UPDATE_ROLE = 'UPDATE_ROLE',
    INDEX_ROLE = 'INDEX_ROLE',
    EDIT_ROLE_PERMISSION = 'EDIT_ROLE_PERMISSION',
    SHOW_ROLE_PERMISSION = 'SHOW_ROLE_PERMISSION',
    SHOW_USER_ROLE = 'SHOW_USER_ROLE',
    EDIT_USER_ROLE = 'EDIT_USER_ROLE',
    SHOW_PERMISSIONS = 'SHOW_PERMISSIONS',
    INDEX_SERVICE = 'INDEX_SERVICE',
    SHOW_SERVICE = 'SHOW_SERVICE',
    STORE_SERVICE = 'STORE_SERVICE',
    DELETE_SERVICE = 'DELETE_SERVICE',
    UPDATE_SERVICE = 'UPDATE_SERVICE',
    INDEX_SERVICE_ZONE = 'INDEX_SERVICE_ZONE',
    SHOW_SERVICE_ZONE = 'SHOW_SERVICE_ZONE',
    STORE_SERVICE_ZONE = 'STORE_SERVICE_ZONE',
    UPDATE_SERVICE_ZONE = 'UPDATE_SERVICE_ZONE',
    DELETE_SERVICE_ZONE = 'DELETE_SERVICE_ZONE',
    INDEX_SUBSCRIPTION = 'INDEX_SUBSCRIPTION',
    SHOW_SUBSCRIPTION = 'SHOW_SUBSCRIPTION',
    STORE_SUBSCRIPTION = 'STORE_SUBSCRIPTION',
    UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION',
    DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION',
    INDEX_PATIENT = 'INDEX_PATIENT',
    SHOW_PATIENT = 'SHOW_PATIENT',
    STORE_PATIENT = 'STORE_PATIENT',
    DELETE_PATIENT = 'DELETE_PATIENT',
    UPDATE_PATIENT = 'UPDATE_PATIENT',
    DELETE_CATEGORY = 'DELETE_CATEGORY',
    INDEX_CATEGORY = 'INDEX_CATEGORY',
    INDEX_ALL_CATEGORIES = 'INDEX_ALL_CATEGORIES',
    SHOW_CATEGORY = 'SHOW_CATEGORY',
    STORE_CATEGORY = 'STORE_CATEGORY',
    UPDATE_CATEGORY = 'UPDATE_CATEGORY',
    INDEX_APPOINTMENT = 'INDEX_APPOINTMENT',
    SHOW_APPOINTMENT = 'SHOW_APPOINTMENT',
    GENERATE_CONSENT_FORM = 'GENERATE_CONSENT_FORM',
    GENERATE_REFUSAL_FORM = 'GENERATE_REFUSAL_FORM',
    GENERATE_MEDICAL_RECORD_FORM = 'GENERATE_MEDICAL_RECORD_FORM',
    SEND_USER_EMAIL_OTP = 'SEND_USER_EMAIL_OTP',
    STORE_APPOINTMENT = 'STORE_APPOINTMENT',
    STORE_APPOINTMENT_DOCUMENT = 'STORE_APPOINTMENT_DOCUMENT',
    STORE_PATIENT_DOCUMENT = 'STORE_PATIENT_DOCUMENT',
    UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT',
    DELETE_APPOINTMENT = 'DELETE_APPOINTMENT',
    DELETE_APPOINTMENT_DOCUMENT = 'DELETE_APPOINTMENT_DOCUMENT',
    DELETE_PATIENT_DOCUMENT = 'DELETE_PATIENT_DOCUMENT',
    UPDATE_APPOINTMENT_ITEM = 'UPDATE_APPOINTMENT_ITEM',
    DELETE_APPOINTMENT_ITEM = 'DELETE_APPOINTMENT_ITEM',

    // Content
    INDEX_STATIC_CONTENT = 'INDEX_STATIC_CONTENT',
    SHOW_STATIC_CONTENT = 'SHOW_STATIC_CONTENT',
    STORE_STATIC_CONTENT = 'STORE_STATIC_CONTENT',
    UPDATE_STATIC_CONTENT = 'UPDATE_STATIC_CONTENT',
    DELETE_STATIC_CONTENT = 'DELETE_STATIC_CONTENT',

    INDEX_BANNER = 'INDEX_BANNER',
    SHOW_BANNER = 'SHOW_BANNER',
    STORE_BANNER = 'STORE_BANNER',
    UPDATE_BANNER = 'UPDATE_BANNER',
    DELETE_BANNER = 'DELETE_BANNER',

    INDEX_HOME_TILE = 'INDEX_HOME_TILE',
    SHOW_HOME_TILE = 'SHOW_HOME_TILE',
    STORE_HOME_TILE = 'STORE_HOME_TILE',
    UPDATE_HOME_TILE = 'UPDATE_HOME_TILE',
    DELETE_HOME_TILE = 'DELETE_HOME_TILE',

    // Finance
    INDEX_INVOICE = 'INDEX_INVOICE',
    SHOW_INVOICE = 'SHOW_INVOICE',
    UPDATE_INVOICE = 'UPDATE_INVOICE',
    INDEX_ANALYTICS = 'INDEX_ANALYTICS',

    // Support
    INDEX_CONVERSATION = 'INDEX_CONVERSATION',
    SHOW_CONVERSATION = 'SHOW_CONVERSATION',
    UPDATE_CONVERSATION = 'UPDATE_CONVERSATION',
    REPLY_CONVERSATION = 'REPLY_CONVERSATION',
    DELETE_CONVERSATION = 'DELETE_CONVERSATION',
    INDEX_SUPPORT_TICKET = 'INDEX_SUPPORT_TICKET',
    SHOW_SUPPORT_TICKET = 'SHOW_SUPPORT_TICKET',
    UPDATE_SUPPORT_TICKET = 'UPDATE_SUPPORT_TICKET',
    DELETE_SUPPORT_TICKET = 'DELETE_SUPPORT_TICKET',
    INDEX_CREDENTIAL_CHANGE_RECORD = 'INDEX_CREDENTIAL_CHANGE_RECORD',
    SHOW_CREDENTIAL_CHANGE_RECORD = 'SHOW_CREDENTIAL_CHANGE_RECORD',
    STORE_CREDENTIAL_CHANGE_RECORD = 'STORE_CREDENTIAL_CHANGE_RECORD',
    MANAGE_AI_FEATURES = 'MANAGE_AI_FEATURES',
    VIEW_AI_USAGE = 'VIEW_AI_USAGE',
    MANAGE_AI_KEYS = 'MANAGE_AI_KEYS'
}
